import { Box, Button, Grid, Table, TableBody, TableHead, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useCallback, useEffect, useState } from "react";
import StyledTableCell from "../../Components/Tables/StyledTableCell";
import StyledTableRow from "../../Components/Tables/StyledTableRow";
import GetAppIcon from "@mui/icons-material/GetApp";
import service from "../../Helpers/gifservices";
import { useLoading } from "../../../../providers/loadingProvider";

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
}));

const getFileType=(fileEnd)=>{
  switch(fileEnd){
    case ".doc":
      return "WORD";
    case ".pdf":
      return "PDF";
    case ".xlsx":
      return "EXCEL";
      default:
        return ""
  }
}

const fixFileName = (fileName) => {
  let cutStartIndex = fileName.indexOf("_");
  if (cutStartIndex < 0) {
    cutStartIndex = 0;
  }
  const fileType = fileName.slice(fileName.indexOf("."), fileName.length);
  
  

  fileName = `${fileName.slice(cutStartIndex +1,fileName.indexOf("."))} ${getFileType(fileType)}`;
  return fileName;
};

export default function Forms() {
  const classes = useStyles();
  const loading = useLoading();
  const [forms, setForms] = useState([]);
  const tableHeaders = [
    { label: "Document Title", width: "15%" },
    { label: "Description", width: "60%" },
    { label: "Download", width: "15%" },
  ];

  const getFiles = useCallback(async () => {
    const loadingId = loading.addLoading("Loading Files");
    const forms = [];
    const preGrantFiles = await service.getResearchAuthoritiesFiles({
      folderName: "PreGrant",
    });
    preGrantFiles.forEach((file) => {
      forms.push({
        documentTitle: "Pre Grant",
        name:fixFileName(file.name),
        description: file.name,
        id: file.id,
      });
    });
    const OngoingGrantFiles = await service.getResearchAuthoritiesFiles({
      folderName: "OngoingGrant",
    });
    OngoingGrantFiles.forEach((file) => {
      forms.push({
        documentTitle: "Ongoing Grant",
        name:fixFileName(file.name),
        description: file.name,
        id: file.id,
      });
    });
    setForms(forms);
    loading.removeLoading(loadingId);
  },[loading]);

  const downloadFile = async (id, fileName) => {
    var data = await service.downloadFiles({ fullPath: id });
    if (!(data instanceof Blob)) {
      return;
    }
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${fileName}`;
    link.click();
  };

  useEffect(() => {
    getFiles();
  }, [getFiles]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box className={classes.header}>
          <Typography variant="subtitle2">Forms</Typography>
          <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
        </Box>
      </Grid>
      <Table className={classes.table}>
        <TableHead>
          <StyledTableRow>
            {tableHeaders.map((header) => (
              <StyledTableCell
                key={header.label}
                style={{ width: header.width }}
              >
                {header.label}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {forms.map((form, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>{form.documentTitle}</StyledTableCell>
              <StyledTableCell>{form.name}</StyledTableCell>
              <StyledTableCell>
                <Button
                  startIcon={<GetAppIcon />}
                  className={classes.button}
                  size="small"
                  onClick={() => downloadFile(form.id, form.description)}
                >
                  Download File
                </Button>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
}
